import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { SubfamiliaProdutosService, notification } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import subfamiliaProdutosValidator from "./middlewares/subfamiliaProdutos.validator";
import { SubfamiliaProdutoEntity } from "../entities";

const AddSubfamiliaProdutos = ({
  id,
  handleCloseDialog,
  buscaSubfamiliasProdutos,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const [loading, setLoading] = useState(false);
  const [subfamiliaProdutos, setSubfamiliaProdutos] = useState({
    ativado: true,
  });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const subfamiliaProdutosService = new SubfamiliaProdutosService();

  useEffect(() => {
    if (id) {
      buscarSubfamiliaProdutos();
    }
  }, []);

  const buscarSubfamiliaProdutos = async () => {
    setLoading(true);
    const result = await subfamiliaProdutosService.getById(id);
    if (!result.isAxiosError) {
      setSubfamiliaProdutos(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleInputChange = (event) => {
    setSubfamiliaProdutos((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    subfamiliaProdutosValidator
      .validate(subfamiliaProdutos, { abortEarly: false })
      .then(async () => {
        const subfamiliaProdutoEntity = new SubfamiliaProdutoEntity(
          subfamiliaProdutos
        );
        if (id) {
          const response = await subfamiliaProdutosService.atualizar(
            id,
            subfamiliaProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaSubfamiliasProdutos();
          } else {
            responseErros(response);
          }
        } else {
          const response = await subfamiliaProdutosService.cadastrar(
            subfamiliaProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.cadastroSucesso();
            buscaSubfamiliasProdutos();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setSubfamiliaProdutos(null);
    handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={
            id
              ? "Editar Subfamília de Produtos"
              : "Cadastrar Subfamília de Produtos"
          }
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={
                    subfamiliaProdutos?.ativado
                      ? subfamiliaProdutos?.ativado
                      : false
                  }
                  onChange={() =>
                    setSubfamiliaProdutos((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={subfamiliaProdutos?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={
                  subfamiliaProdutos?.descricao
                    ? subfamiliaProdutos.descricao
                    : ""
                }
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddSubfamiliaProdutos;
